module.exports = __webpack_public_path__ + "static/media/rules-puzzle-halfway-dark.ef704d40.png";